import stationConfig from "../config/stationConfig"

function searchForUUIDs(children) {
    var uuids = [];
    if (children) {
        for (var key in children) {
            var child = children[key];
            console.log(child)
            if (typeof child.uuid != 'undefined') {
                console.log("UUID")
                uuids.push(child.uuid);
            }

            if (typeof child.children != 'undefined') {
                uuids.push(...searchForUUIDs(child.children))
            }
        }
    }

    return uuids;
}

function flattenToList(all_data, group_name, data) {

    if (typeof all_data[data.group] == 'undefined') {
        // debugger;
        all_data[data.group] = {
            label: data.label,
            colour: data.colour,
            groups: {},
            keys: {}
        }
    }

    if (typeof all_data[data.group].groups[group_name] == 'undefined') {
        console.log(data)
        let uuids = typeof data.uuid != 'undefined' ? [data.uuid] : searchForUUIDs(data.children);

        all_data[data.group].groups[group_name] = {
            label: data.label,
            colour: data.colour,
            key: group_name,
            uuids,

        }

        all_data[data.group].keys = { ...all_data[data.group].keys, ...keyCreator(uuids, group_name) }

    }

    for (var key in data.children) {
        all_data = { ...all_data, ...flattenToList(all_data, key, data.children[key]) }
    }

    return all_data;
}

function keyCreator(uuids, key) {
    var ret = {};
    for (var uuid of uuids) {
        ret[uuid] = key;
    }

    return ret;
}

export default flattenToList({}, "all", stationConfig.tree);